if (!window.direct) {
    window.direct = {};
}

import "./modules/darkmode";
import "./modules/utils";
import "./modules/scroll";
import "./modules/anchor";
import "./modules/search";
import "./modules/navigation";
import "./modules/code";
import "./modules/table";
import "./modules/popover";
import "./modules/video";
import "./modules/thumbs";
import "./modules/svg";
import "./modules/showmore";
import "./modules/animation";
import "./modules/checkbox";
import "./modules/signup.js";
import "./modules/nav-mobile-v2.js";
import "./modules/text-to-speech/text-to-speech.js";
